export default "__VITE_ASSET__BGjWCQBb__"